/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { fetchData } from "@jda/lui-portal-utilities";

import { createRequestObject, getAuthToken } from "../utility/commonUtility";
const { MANAGEMENT_SERVICE_URL } = window.env;

export const getAllGeos = async () => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/system-specs/geos`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};

export const getAllEnvTypes = async () => {
  const apiURL = `${MANAGEMENT_SERVICE_URL}/system-specs?page-number=1&page-size=50&sort-order=ASC`;
  return fetchData<any>(createRequestObject(apiURL), getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};
